export default {
  zh: {
    yourFriends: '您邀请的好友',
    bought: '购买了',
    devices: '台设备',
    '年付': '年付',
    '季付': '季付',
    '月付': '月付',
    '连续订阅': '月付',
    '12 Months': '年付',
    '3 Months': '季付',
    '1 Month': '月付',
    'Monthly Subscription': '月付',
    plan: '套餐',
    days: '天',
    beAwarded: '，您获得奖励',
    refunded: '，已取消服务。',
    time: '时间',
    description: '描述',
    amount: '天数',
    ':': '：'
  },
  en: {
    yourFriends: 'Your friend',
    bought: 'have purchased',
    devices: 'device | devices',
    '年付': '12 months',
    '季付': '3 months',
    '月付': '1 month',
    '连续订阅': '1 month',
    '12 Months': '12 months',
    '3 Months': '3 months',
    '1 Month': '1 month',
    'Monthly Subscription': '1 month',
    plan: ' plan ',
    days: 'day | days',
    beAwarded: ', you have got free service time.',
    refunded: ', which has been cancelled.',
    time: 'Time',
    description: 'Description',
    amount: 'Amount',
    ':': ': '
  }
}



// WEBPACK FOOTER //
// ./src/components/affiliate/rewardRecords/lang.js